import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLighthouseComponent } from './simple-icons-lighthouse.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLighthouseComponent ],
    exports:      [ SimpleIconsLighthouseComponent ],
    bootstrap:    []
})
export class SimpleIconsLighthouseModule {}
